import { useEffect } from "react";

import { usePlatformSimpleLogo } from "../api/queries/usePlatformSimpleLogo";

const DEFAULT_FAVICON_SRC = "/apple-touch-icon.png";

export function PlatformFavicon() {
  const { data: platformSimpleLogoUrl, isLoading } = usePlatformSimpleLogo();

  useEffect(() => {
    if (isLoading) return;

    const finalUrl = platformSimpleLogoUrl || DEFAULT_FAVICON_SRC;

    const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
    existingFavicons.forEach((link) => link.remove());

    const link = document.createElement("link");
    link.rel = "icon";
    link.type = platformSimpleLogoUrl ? "image/webp" : "image/png";
    link.href = finalUrl;
    document.head.appendChild(link);
  }, [platformSimpleLogoUrl, isLoading]);

  return null;
}
